import { Limit } from '../responsible-gaming';
import { Transaction } from '../wallet/types';

// eslint-disable-next-line import/no-unused-modules
export enum LIMIT_TYPE {
    DEPOSIT = 'deposit',
    LOSS = 'loss',
    LOGIN_DURATION = 'login_duration',
    WAGERING = 'wager',
}

export type UserLimit = { activeLimit: Limit; upcomingLimit: Limit };
export enum LIMIT_PERIOD {
    NO_LIMIT = 'no_limit',
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
}

export enum ResponsibleGamingProduct {
    CASINO = 'casino',
    HORSE_RACING = 'horse_racing',
    POKER = 'poker',
    SPORTSBOOK = 'sportsbook',
}

export type SelfExclusionUntilFurtherNotice = {
    notice_date: Date;
};

export type ExclusionPeriod = {
    label: string;
    periodInDays: number;
    isUntilFurtherNotice?: boolean;
};

export enum TimeoutItemSource {
    PANIC_BUTTON = 'panic button',
    PRODUCT_BLOCKING = 'product blocking',
    SELF_EXCLUSION = 'self exclusion',
}

export type ResponsibleGamingReminder = {
    action: string;
    id: string;
    userId: string;
    limit_end?: string;
    reason?: string;
    sessionStart: string;
    wallet_data: Transaction[];
    wallet_total?: number;
    kycToken?: string;
    kycTokenExpiry?: string;
};
